import {
  AppBar,
  Button,
  Toolbar,
  IconButton,
  Menu as ReactMenu,
  MenuItem,
  ClickAwayListener,
} from "@mui/material";
import "./App.css";
import Home from './components/home/home';
import logo from "./img/banjirmission_logo.png";
import About from "./components/about/about";
import React from "react";
import Menu from "@mui/icons-material/Menu";
import { Link } from "react-scroll";
import Footer from "./components/footer/footer";
import Donate from "./components/donate/donate";
import Contact from "./components/contact/contact";

function App() {
  const pages = ["About", "Donate", "Contact"];
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const routeToPage = (page) => {
    if (page === "About") {
      return "about";
    } else if (page === "Donate") {
      return "donation";
    } else if (page === "Gallery") {
      return "gallery";
    } else {
      return "contact";
    }
  };
  return (
    <div style={{ overflowX: "hidden" }}>
      <AppBar position="static" style={{ backgroundColor: "#000" }}>
        <Toolbar>
          <div className="d-flex me-auto">
            <img src={logo} className="logo-img" alt="" draggable={false} />
            <div className="mt-4">
              <p className="header-title">Banjir Mission</p>
            </div>
          </div>
          <div className="menu-button">
            {pages.map((x) => {
              return (
                <Button
                  disableElevation={true}
                  style={{ color: "#fff", margin: "5pt" }}
                  variant="contained"
                  key={x}
                >
                  <Link to={routeToPage(x)}>{x}</Link>
                </Button>
              );
            })}
          </div>
          <div className="more-options-button">
            <ClickAwayListener onClickAway={handleClose}>
              <IconButton
                onClick={handleClick}
                color="primary"
                aria-label="add to shopping cart"
              >
                <Menu style={{ color: "#fff" }} />
              </IconButton>
            </ClickAwayListener>
            <ReactMenu id="header-menu" open={open} anchorEl={anchorEl}>
              {pages.map((x, i) => {
                return (
                  <Link to={routeToPage(x)} key={i}>
                    <MenuItem onClick={handleClose}>{x}</MenuItem>
                  </Link>
                );
              })}
            </ReactMenu>
          </div>
        </Toolbar>
      </AppBar>
      <Home />
      <About />
      <Donate />
      <Contact />
      <Footer />
    </div>
  );
}
export default App;
